export const STRING_LENGTH = 'STRING_LENGTH_';

export function erreurStringLength(message, champs, messages, preMessage) {
  let max = message.slice(STRING_LENGTH.length, message.indexOf('|'));
  let min = 0;
  let infoChamps = champs;
  let nouveauMessage = '';
  if (max.indexOf('_') !== -1) {
    min = max.split('_')[0];
    max = max.split('_')[1];
    if (min === '1' && !max) {
      nouveauMessage = 'validation.stringLength.fieldWithMinIsOne';
    } else {
      nouveauMessage = 'validation.stringLength.fieldWithMin';
    }
  } else {
    nouveauMessage = 'validation.stringLength.field';
  }
  if (champs.message && champs.message.indexOf('.') !== -1) {
    const champsSplice = champs.message.split('.');
    infoChamps = champsSplice[champsSplice.length - 1];
  }
  if (infoChamps === 'adressePostale.Intitule'
    && nouveauMessage === 'validation.stringLength.fieldWithMinIsOne') {
    messages.push({ message: 'validation.addressIntitituleRequired' });
    return;
  }
  if (infoChamps === 'adressePostale.Ville'
    && nouveauMessage === 'validation.stringLength.fieldWithMinIsOne') {
    messages.push({ message: 'validation.addressVilleRequired' });
    return;
  }
  if (infoChamps === 'adressePostale.Intitule'
    && nouveauMessage === 'validation.stringLength.fieldWithMin') {
    messages.push({ message: 'validation.stringLength.intituleWithMinMax', parametres: { min: min, max: max } });
    return;
  }
  if (infoChamps === 'adressePostale.Ville'
    && nouveauMessage === 'validation.stringLength.fieldWithMin') {
    messages.push({ message: 'validation.stringLength.adressVilleWithMinMax', parametres: { min: min, max: max } });
    return;
  }
  if (messages.some(m => {
    return m.parametres && m.parametres.name === infoChamps;
  })) return;
  messages.push({
    message: nouveauMessage,
    parametres: { name: infoChamps, min: min, max: max },
    preMessage: preMessage,
  });
}
